import React from 'react';
import PropTypes from 'prop-types';

const ActivationKeyIcon = ({ size = '32px', fill = '#000' }) => (
  <svg
    id="ActivationKey"
    height={size}
    viewBox="0 0 512 512"
    width={size}
  >
    <g>
      <path d="m437 211c-41.367 0-75 33.647-75 75v15c-19.302 0-117.632 0-137 0-8.291 0-15 6.709-15 15v60c0 8.291 6.709 15 15 15h60c8.291 0 15-6.709 15-15v-45h62v15c0 41.353 33.633 75 75 75s75-33.647 75-75v-60c0-41.353-33.633-75-75-75zm15 135c0 8.291-6.709 15-15 15s-15-6.709-15-15v-60c0-8.291 6.709-15 15-15s15 6.709 15 15z" fill={fill}/>
      <path d="m180 376v-60c0-24.814 20.186-45 45-45h45v-45c0-8.291-6.709-15-15-15h-240c-8.291 0-15 6.709-15 15v240c0 8.291 6.709 15 15 15h240c8.291 0 15-6.709 15-15v-45h-45c-24.814 0-45-20.186-45-45zm-30 0c0 8.291-6.709 15-15 15s-15-6.709-15-15v-60c0-8.291 6.709-15 15-15s15 6.709 15 15z" fill={fill}/>
      <path d="m60 136c0-41.353 33.633-75 75-75s75 33.647 75 75v45h30v-45c0-57.891-47.109-105-105-105s-105 47.109-105 105v45h30z" fill={fill}/>
    </g>
  </svg>
);

ActivationKeyIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};
export default ActivationKeyIcon;
